import { Card, Col, Row, Timeline, Flex, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useBreakpoint } from '../hooks/breakpoint';
import StyledContainer from './StyledContainer';

const StyledListItem = styled.div`
  padding: 6px 16px !important;
  text-align: justify;
  display: flex; // Maintain flex behavior if needed
  align-items: center;
`;

const StyledListItemTeckStack = styled.div`
  padding: 6px 16px !important;
  text-align: left;
  display: flex;
`;

const Experience = ({ Data, i18 }) => {
  const [loading, setLoading] = useState(true);
  const isMD = useBreakpoint();

  useEffect(() => {
    setLoading(false);
  }, []);

  const timelineItems = (page, size) => {
    const startIndex = (page - 1) * size;
    const endIndex = startIndex + size;

    return Data.experiences.slice(startIndex, endIndex).map((experience, index) => ({
      children: (
        <Row>
          <Col span={24}>
            <Typography.Text level={5}>{experience.company}</Typography.Text>
          </Col>
          <Col span={24}>
            <Typography.Text type="secondary">
              {experience.from} - {experience.to}
            </Typography.Text>
          </Col>
          <Col span={24}>
            <Typography.Text strong>{experience.position}</Typography.Text>
          </Col>
          <Col span={24}>
            {/* Responsibilities */}
            <Flex
              vertical
              style={{
                width: '100%',
                alignItems: !isMD || index % 2 === 0 ? 'flex-start' : 'flex-end'
              }}
            >
              {experience.responsibilities?.map((item, idx) => (
                <StyledListItem key={idx}>
                  <Typography.Text>
                    - {item}
                  </Typography.Text>
                </StyledListItem>
              ))}
            </Flex>

            <Typography.Title level={5} type="secondary" style={{ textAlign: 'center', marginTop: 16 }}>
              {i18.TIT_TECK_STACK}
            </Typography.Title>

            {/* Tech Stack */}
            <Flex vertical style={{ width: '100%' }}>
              {experience.techStack?.map((item, idx) => (
                <StyledListItemTeckStack key={idx}>
                  <Typography.Text style={{ fontFamily: "Inconsolata !important", fontSize: 13, color: '#4a4a4a' }}>
                    {item}
                  </Typography.Text>
                </StyledListItemTeckStack>
              ))}
            </Flex>
          </Col>
        </Row >
      ),
      key: index,
    }))
  };

  return (
    <React.Fragment>
      <div className="section" id="experience">
        <StyledContainer>
          <Col span={24}>
            <Row>
              <Col span={24}>
                <Typography.Title level={3} style={{ textAlign: 'center' }}>
                  {i18.TIT_EXPERIENCE}
                </Typography.Title>
              </Col>
              <Col span={24}>
                <Typography.Title
                  level={5}
                  style={{
                    textAlign: 'center',
                    marginBottom: '2rem',
                    color: 'darkgray',
                  }}
                >
                  {Data.getExperienceDuration()}
                </Typography.Title>
              </Col>
              <Col span={24}>
                <Card
                  loading={loading}
                  style={{ cursor: 'default' }}
                  hoverable
                  variant="outlined"
                  className="z-shadow"
                >
                  <Row>
                    {[1, 2].map((page) =>
                      <Col key={page}
                        xl={12}
                        lg={12}
                        md={12}
                        sm={24}
                        xs={24}>
                        <Typography.Title level={5} type="secondary" style={{ textAlign: 'center', marginTop: 16 }}>
                          {page}
                        </Typography.Title>
                        <Timeline items={timelineItems(page, 4)} />
                      </Col>
                    )}
                  </Row>
                </Card>
              </Col>
            </Row>
          </Col>

        </StyledContainer>
      </div>
    </React.Fragment>
  );
};

export default Experience;
